"use client";

import { X } from "lucide-react";

interface FilterChipProps {
  label: string;
  value?: string;
  onRemove?: () => void;
  onClick?: () => void;
  active?: boolean;
  className?: string;
}

export function FilterChip({
  label,
  value,
  onRemove,
  onClick,
  active = false,
  className = "",
}: FilterChipProps) {
  return (
    <div
      className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-lg text-sm font-medium transition-all cursor-pointer border ${
        active
          ? "bg-[var(--color-accent-yellow)]/20 border-[var(--color-accent-yellow)] text-[var(--color-text-primary)]"
          : "bg-[var(--color-surface)] border-[var(--color-border)] text-[var(--color-text-secondary)] hover:border-[var(--color-text-muted)]"
      } ${className}`}
      onClick={onClick}
    >
      <span className="text-[var(--color-text-muted)]">{label}</span>
      {value && (
        <>
          <span className="text-[var(--color-border)]">:</span>
          <span>{value}</span>
        </>
      )}
      {onRemove && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove();
          }}
          className="p-0.5 rounded hover:bg-[var(--color-surface-hover)] transition-colors"
          aria-label={`${label} 제거`}
        >
          <X className="w-3 h-3" />
        </button>
      )}
    </div>
  );
}

export type { FilterChipProps };
